import { getRouteIdFromPathname } from './getRouteIdFromPathname';
import type { RouteDefinition } from './routes';

export const isCurrentRoute = (route: RouteDefinition) => {
  return getRouteIdFromPathname(window.location.pathname) === route.id;
};
